import React from 'react';

const ExtrasShopPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-100 to-yellow-100 py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold text-green-800 mb-4">The Extras Shop</h1>
            <p className="text-xl text-gray-700 mb-8">
              Pro shop essentials for the serious player.
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-green-50 p-8 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">🖊️</div>
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Racquet Pens</h3>
              <p className="text-gray-700 mb-6">In different "string" colors.</p>
              <button className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300">
                Add to Cart
              </button>
            </div>
            <div className="bg-yellow-50 p-8 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">📄</div>
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Court Strategy Posters</h3>
              <p className="text-gray-700 mb-6">Visual reminders for home/office.</p>
              <button className="bg-yellow-500 hover:bg-yellow-600 text-green-800 font-semibold py-2 px-4 rounded-md transition duration-300">
                Add to Cart
              </button>
            </div>
            <div className="bg-green-50 p-8 rounded-lg shadow-md text-center">
              <div className="text-4xl mb-4">🎁</div>
              <h3 className="text-2xl font-semibold text-green-800 mb-4">Gift Cards</h3>
              <p className="text-gray-700 mb-6">For coaches to give to students.</p>
              <button className="bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded-md transition duration-300">
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ExtrasShopPage;

